import { createApp } from 'vue'
import StafetDeltagPaaHoldStepThree from './StafetDeltagPaaHoldStepThree'

const el = '.kb-component--stafet-join-a-team-step-three'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDeltagPaaHoldStepThreeDOM) => {
            const component = createApp(StafetDeltagPaaHoldStepThree).use(Store)
            component.mount(StafetDeltagPaaHoldStepThreeDOM)
        })
    }
}
